import { render, staticRenderFns } from "./KusClientForm.vue?vue&type=template&id=b5311238"
import script from "./KusClientForm.vue?vue&type=script&lang=js"
export * from "./KusClientForm.vue?vue&type=script&lang=js"
import style0 from "./KusClientForm.vue?vue&type=style&index=0&id=b5311238&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports